import React, { useEffect, useState } from 'react';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { useTranslation } from 'react-i18next';
import { Button } from '@mui/material';

const Section1 = () => {
  const { t, i18n } = useTranslation();

  const handleScroll = (id) => {
    const element = document.getElementById(id);
    if (element) {
      window.scrollTo({
        top: element.offsetTop - 80,
        behavior: 'smooth',
      });
    }
  };

  return (
    <div
      style={{
        backgroundColor: '#000000',
        minHeight: '100vh',
        marginTop: '-80px',
        paddingBottom: '100px',
      }}
    >
      <div
        className="container"
        style={{ paddingTop: '180px', textAlign: 'center', maxWidth: '1000px' }}
      >
        <h1 className="title white">
          {t('discoverService')}{' '}
          <span className="gradient-text">{t('renew')} </span>
          {t('qcIndustry')}
        </h1>
        <p className="text white mt-3">{t('trailerTxt')}</p>
        <Button
          onClick={() => handleScroll('section2')}
          className="mt-4"
          variant="contained"
          color="primary"
          style={{
            backgroundColor: '#04aee7',
            color: '#FFFFFF',
            borderRadius: '30px',
            padding: '8px 12px',
          }}
        >
          {t('getQuote')}
        </Button>
      </div>
      <div className="mt-5">-</div>
      <div className="mt-5 container">
        <div className="row mt-4">
          <div className="col-md-3 col-12">
            <div className="px-4">
              <img src="/img/palette.png" width={130} alt="palette" />

              <h3 style={{ maxWidth: '90%' }} className="section-title white">
                {t('service1')}
              </h3>
              <p className="text-small white mt-4">
                <li> {t('subS1P1')}</li>
                <li> {t('subS1P2')}</li>
                <li> {t('subS1P3')}</li>
              </p>
              <div
                onClick={() => handleScroll('section2')}
                className="d-flex mt-4"
              >
                <div className="white text-btn mt-1">
                  {t('deliveryRequest')}
                </div>
                <div className="mx-2">
                  <ArrowForwardIosIcon
                    sx={{ fontSize: '14px', marginTop: '5px' }}
                    htmlColor="#FFFFFF"
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-3 col-12">
            {' '}
            <div className="px-4">
              <img src="/img/VTT.png" width={130} alt="VTT" />

              <h3 style={{ maxWidth: '90%' }} className="section-title white">
                {t('service2')}
              </h3>
              <p className="text-small white mt-4">
                <li>{t('subS2P1')}</li>
                <li> {t('subS2P2')}</li>
                <li>{t('subS2P3')}</li>
                <li>{t('subS2P4')}</li>
              </p>
              <div
                onClick={() => handleScroll('section2')}
                className="d-flex mt-4"
              >
                <div className="white text-btn mt-1">
                  {t('deliveryRequest')}
                </div>
                <div className="mx-2">
                  <ArrowForwardIosIcon
                    sx={{ fontSize: '14px', marginTop: '5px' }}
                    htmlColor="#FFFFFF"
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-3 col-12">
            {' '}
            <div className="px-4">
              <img src="/img/sofa.png" width={130} alt="sofa" />

              <h3 style={{ maxWidth: '90%' }} className="section-title white">
                {t('service3')}
              </h3>
              <p className="text-small white mt-4">
                <li>{t('subS3P1')}</li>
                <li> {t('subS3P2')}</li>
              </p>
              <div
                onClick={() => handleScroll('section2')}
                className="d-flex mt-4"
              >
                <div className="white text-btn mt-1">
                  {t('deliveryRequest')}
                </div>
                <div className="mx-2">
                  <ArrowForwardIosIcon
                    sx={{ fontSize: '14px', marginTop: '5px' }}
                    htmlColor="#FFFFFF"
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-3 col-12">
            {' '}
            <div className="px-4">
              <img src="/img/sable.png" width={130} alt="sable" />

              <h3 style={{ maxWidth: '90%' }} className="section-title white">
                {t('service4')}
              </h3>
              <p className="text-small white mt-4">
                <li>{t('subS4P1')}</li>
              </p>
              <div
                onClick={() => handleScroll('section2')}
                className="d-flex mt-4"
              >
                <div className="white text-btn mt-1">
                  {t('deliveryRequest')}
                </div>
                <div className="mx-2">
                  <ArrowForwardIosIcon
                    sx={{ fontSize: '14px', marginTop: '5px' }}
                    htmlColor="#FFFFFF"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Section1;
